import { createFileRoute } from '@tanstack/react-router'
import { CategoriesPageLayout } from '~/components/routes/categories/categories-page-layout'
import { LogisticsCategoriesPanel } from '~/components/routes/categories/logistics/logistics-categories-panel'
import { CATEGORIES_TAB_PERMISSIONS } from '~/components/routes/categories/tabs'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/categories/logistics/')({
  staticData: {
    permission: CATEGORIES_TAB_PERMISSIONS.logistics,
  },
  component: LogisticsCategoriesTabPage,
})
withRoutePermissions(Route)

function LogisticsCategoriesTabPage() {
  return (
    <CategoriesPageLayout activeTab="logistics">
      <LogisticsCategoriesPanel />
    </CategoriesPageLayout>
  )
}
